import { connect } from 'react-redux';
import React from 'react';
import PresentationComponent from '../../../components/dashboards/tabcomponents/TemplateDrawerMenu';
import RetentionTemplateDrawer from './RetentionTemplateDrawer';

const mapStateToProps = () => ({
  templateDrawer: (collapsed, setCollapsed) => (
    <RetentionTemplateDrawer collapsed={collapsed} setCollapsed={setCollapsed} />
  ),
});

const RetentionTemplateDrawerMenu = connect(mapStateToProps, null)(PresentationComponent);

export default RetentionTemplateDrawerMenu;
